import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AuthService from "services/auth.service";
import { Row, Col, Input } from "reactstrap";

const Notification = (props) => {
  const { id } = useParams();

  const [title, setTitle] = useState("");
  const [notificationMessage, setNotificationMessage] = useState("");

  const [notifications, setNotifications] = useState([]);
  const [message, setMessage] = useState("");

  const initialUserState = {
    id: null,
    email: "",
  };

  const [currentUser, setCurrentUser] = useState(initialUserState);

  const getUser = (id) => {
    AuthService.get(id)
      .then((response) => {
        setCurrentUser(response.data);
        //console.log(response.data);
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  useEffect(() => {
    if (id) getUser(id);
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await AuthService.registerNotification(
        id,
        title,
        notificationMessage
      );
      setMessage(response.data);
      //console.log(response);
      //console.log(message);

      //console.log("Notification sent successfully");
      setTitle("");
      setNotificationMessage("");
    } catch (error) {
      const resMessage =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      setMessage(resMessage);
      //console.log("Error sending notification");
      //console.log(resMessage);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  // logic to fetch the notification for the admin side
  const fetchNotifications = () => {
    AuthService.fetchNotification(id)
      .then((response) => {
        setNotifications(response.data);
      })
      .catch((error) => console.error("Error fetching notification:", error));
  };

  const handleDeleteNotification = (notificationId) => {
    AuthService.deleteNotification(notificationId)
      .then(() => {
        // Remove the deleted notification from the state
        setNotifications(notifications.filter((n) => n.id !== notificationId));
      })
      .catch((error) => console.error("Error deleting notification:", error));
  };

  const handleResendNotification = (notificationId) => {
    //console.log(notificationId);
    //console.log(notifications.id);
    AuthService.resendNotification(notificationId)
      .then(() => {
        // Update the notification's read status in the state
        setNotifications(
          notifications.map((n) =>
            n.id === notificationId ? { ...n, read: false } : n
          )
        );
       // console.log(notifications);
      })

      .catch((error) => console.error("Error resending notification:", error));
    //console.log(notifications);
  };

  return (
    <div className="content">
      <Row>
        <Col>
          {currentUser ? (
            <div className="edit-form">
              <h4>Notification</h4>
              <form>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="email"
                    value={currentUser.email}
                    disabled
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="userId">User ID:</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="userId"
                    value={currentUser.id}
                    disabled
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="title">Title:</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="msg">Message:</label>
                  <textarea
                    type="text"
                    className="form-control"
                    name="msg"
                    value={notificationMessage}
                    onChange={(e) => setNotificationMessage(e.target.value)}
                    required
                  />
                </div>
              </form>

              {/* <button className="badge badge-danger mr-2" onClick={deleteUser}>
                Delete
              </button> */}

              <button
                type="submit"
                className="badge badge-success"
                onClick={handleSubmit}
              >
                Create Notification
              </button>
              <p>{message}</p>
            </div>
          ) : (
            <div>
              <br />
              <p>Please click on a User...</p>
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col>
          {currentUser ? (
            <div className="edit-form">
              <h4>Notification Directory</h4>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableRowHeader}>
                    <th style={styles.tableHeader}>Title</th>
                    <th style={styles.tableHeader}>Message</th>
                    <th style={styles.tableHeader}>Read Status</th>
                    <th style={styles.tableHeader}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {notifications.map((notification) => (
                    <tr key={notification.id} style={styles.tableRow}>
                      <td style={styles.tableData}>{notification.title}</td>
                      <td style={styles.tableData}>{notification.message}</td>
                      <td style={styles.tableData}>
                        {notification.read ? "Read" : "Unread"}
                      </td>
                      <td style={styles.tableData}>
                        <button
                          style={styles.button}
                          
                          onClick={() =>
                            handleResendNotification(notification.id)
                          }
                        >
                          Resend
                        </button>
                        <button
                          style={styles.buttonR}
                         
                          onClick={() =>
                            handleDeleteNotification(notification.id)
                          }
                        >
                          Delete
                        </button>
                         
                          
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div>
              <br />
              <p>This user has no notification yet..</p>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "20px",
  },
  tableHeader: {
    borderBottom: "2px solid black",
    padding: "10px",
    textAlign: "left",
    backgroundColor: "black",
  },
  tableRowHeader: {
    borderBottom: "1px dotted #ccc",
  },
  tableRow: {
    borderBottom: "1px dotted #ccc",
  },
  tableData: {
    padding: "10px",
  },
  button: {
    marginRight: "10px",
    padding: "5px 10px",
    cursor: "pointer",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    marginBottom: "10px",
  },
  buttonR: {
    marginRight: "10px",
    padding: "5px 10px",
    cursor: "pointer",
    backgroundColor: "red",
    color: "white",
    border: "none",
    borderRadius: "4px",
  },
};
export default Notification;
